module.exports = __webpack_public_path__ + "img/hotel-lisboa-plaza.f9fddc8f.jpg";